<div class="ag-filter-wrapper">
  <div class="ag-filter-body-wrapper">
    <!-- Filter Type Selector -->
    <div class="ag-filter-filter custom-date-filter">
      <mat-form-field
        appearance="outline"
        class="ag-filter-operator-select"
        style="width: 100%"
      >
        <mat-select
          [(ngModel)]="filterType"
          (selectionChange)="onFilterTypeChange()"
          (click)="$event.stopPropagation()"
          (openedChange)="onOperatorSelectOpenedChange($event)"
          panelClass="ag-filter-operator-panel"
        >
          @for (option of filterOptions; track option.value) {
            <mat-option
              [value]="option.value"
              (click)="$event.stopPropagation()"
            >
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Date From Input -->
    @if (showDateInput()) {
      <div class="ag-filter-filter date-input-wrapper">
        <kpi4me-date-element
          [formControlElement]="dateFromControl"
          [label]="showDateTo() ? 'Von' : 'Datum'"
          [required]="false"
        ></kpi4me-date-element>
      </div>
    }

    <!-- Date To Input (only for inRange) -->
    @if (showDateTo()) {
      <div class="ag-filter-filter date-input-wrapper">
        <kpi4me-date-element
          [formControlElement]="dateToControl"
          [label]="'Bis'"
          [required]="false"
        ></kpi4me-date-element>
      </div>
    }

    <!-- Second Condition (UND/ODER Logic) -->
    @if (showSecondCondition()) {
      <div class="ag-filter-condition">
        <div
          class="
            ag-filter-condition-operator
            ag-filter-condition-operator-and
            ag-labeled
            ag-label-align-right
            ag-radio-button
            ag-input-field
          "
          [class.ag-checked]="joinOperator === 'AND'"
        >
          <label class="ag-input-field-label ag-label ag-radio-button-label">UND</label>
          <div
            class="ag-wrapper ag-input-wrapper ag-radio-button-input-wrapper"
            [class.ag-checked]="joinOperator === 'AND'"
          >
            <input
              type="radio"
              name="joinOperator"
              value="AND"
              [(ngModel)]="joinOperator"
              class="ag-input-field-input ag-radio-button-input"
            >
          </div>
        </div>
        <div
          class="
            ag-filter-condition-operator
            ag-filter-condition-operator-or
            ag-labeled
            ag-label-align-right
            ag-radio-button
            ag-input-field
          "
          [class.ag-checked]="joinOperator === 'OR'"
        >
          <label class="ag-input-field-label ag-label ag-radio-button-label">ODER</label>
          <div
            class="ag-wrapper ag-input-wrapper ag-radio-button-input-wrapper"
            [class.ag-checked]="joinOperator === 'OR'"
          >
            <input
              type="radio"
              name="joinOperator"
              value="OR"
              [(ngModel)]="joinOperator"
              class="ag-input-field-input ag-radio-button-input"
            >
          </div>
        </div>
      </div>

      <!-- Second Filter Type Selector -->
      <div class="ag-filter-filter custom-date-filter">
        <mat-form-field
          appearance="outline"
          class="ag-filter-operator-select"
          style="width: 100%"
        >
          <mat-select
            [(ngModel)]="filterType2"
            (click)="$event.stopPropagation()"
            (openedChange)="onOperatorSelectOpenedChange($event)"
            panelClass="ag-filter-operator-panel"
          >
            @for (option of filterOptions; track option.value) {
              <mat-option
                [value]="option.value"
                (click)="$event.stopPropagation()"
              >
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Second Date From Input -->
      @if (showDateInput2()) {
        <div class="ag-filter-filter date-input-wrapper">
          <kpi4me-date-element
            [formControlElement]="dateFrom2Control"
            [label]="showDateTo2() ? 'Von' : 'Datum'"
            [required]="false"
          ></kpi4me-date-element>
        </div>
      }

      <!-- Second Date To Input (only for inRange) -->
      @if (showDateTo2()) {
        <div class="ag-filter-filter date-input-wrapper">
          <kpi4me-date-element
            [formControlElement]="dateTo2Control"
            [label]="'Bis'"
            [required]="false"
          ></kpi4me-date-element>
        </div>
      }
    }

    <!-- Apply and Clear Buttons -->
    <div class="ag-filter-apply-panel">
      <button
        type="button"
        class="ag-standard-button ag-filter-apply-panel-button"
        (click)="applyFilter()"
      >
        Anwenden
      </button>

      <button
        type="button"
        class="ag-standard-button ag-filter-apply-panel-button"
        (click)="clearFilter()"
      >
        Zurücksetzen
      </button>
    </div>
  </div>
</div>
